export default __webpack_public_path__ + "static/media/ic_copy_24px.1a662206.svg";